import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {FEATURES_DEFAULT} from 'modules/features-toggle/constants';
import {selectFeaturesList} from 'modules/features-toggle/selectors';
import {TFeaturesResponse} from 'modules/features-toggle/types';
import React, {createContext} from 'react';
export const FeaturesToggleContext = createContext<TFeaturesResponse>(FEATURES_DEFAULT);
export const FeaturesToggleProvider: FC = ({children}) => {
    const features = useAppSelector(selectFeaturesList) ?? FEATURES_DEFAULT;

    return <FeaturesToggleContext.Provider value={features}>{children}</FeaturesToggleContext.Provider>;
};
